// src/pages/ContinueInApp.js
// v4 – simplified handoff with one clear next action
//
// Changes vs v3:
// ✅ Removes equal-weight dual-path choice framing
// ✅ Makes the phone handoff the primary story
// ✅ Keeps QR as fallback support, not primary decision
// ✅ Uses shared config install URL
// ✅ Reinforces "same details you just created"

import React from "react";
import { useLocation, Link } from "react-router-dom";
import QRCode from "react-qr-code";

import { ROUTES, MOBILE_APP_INSTALL_URL } from "../config";
import "../styles/ContinueInApp.css";

const ContinueInApp = () => {
  const location = useLocation();
  const emailFromState = location.state?.email || "";

  return (
    <div className="continue-in-app-page">
      <div className="continue-in-app-shell">
        <div className="continue-in-app-hero">
          <div className="continue-in-app-badge">Ready to go</div>
          <h1 className="continue-in-app-title">You&apos;re ready to go</h1>

          <p className="continue-in-app-subtitle">
            Next, open the GhrianGhraffy App on your phone to finish setting up your school.
          </p>

          <a
            className="continue-in-app-button primary"
            href={MOBILE_APP_INSTALL_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            Open on your phone
          </a>

          <p className="continue-in-app-note">
            You&apos;ll use the same details you just created. It only takes about a minute.
          </p>
        </div>

        <section className="continue-in-app-card">
          <h2 className="continue-in-app-card-title">Use the same details</h2>

          <div className="continue-in-app-credential-box">
            <div className="continue-in-app-credential-row">
              <div className="continue-in-app-credential-label">Email</div>
              <div className="continue-in-app-credential-value">
                {emailFromState || "Your registered email"}
              </div>
            </div>

            <div className="continue-in-app-credential-row">
              <div className="continue-in-app-credential-label">Password</div>
              <div className="continue-in-app-credential-value">
                The password you just created
              </div>
            </div>
          </div>
        </section>

        <section className="continue-in-app-card">
          <h2 className="continue-in-app-card-title">Don&apos;t have it yet?</h2>
          <p className="continue-choice-helper">
            Open the install page on your phone, or scan this code with your phone camera.
          </p>

          <div className="continue-in-app-footer-actions" style={{ marginBottom: 20 }}>
            <a
              className="continue-in-app-button primary"
              href={MOBILE_APP_INSTALL_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              Open install page
            </a>

            <Link className="continue-in-app-button secondary" to={ROUTES.LOGIN}>
              Back to Login
            </Link>
          </div>

          <div className="continue-in-app-qr-frame">
            <QRCode value={MOBILE_APP_INSTALL_URL} size={150} />
          </div>
        </section>
      </div>
    </div>
  );
};

export default ContinueInApp;